module.exports = __webpack_public_path__ + "static/media/marker.938ca751.png";